"use client";

import cx from "classnames";
import Link from "next/link";
import OddsBtn, { useRedirectConfirmationModal } from "@/components/oddsBtn";
import RedirectToSportsbook from "@/events/Modals/RedirectToSportsbookModal";
import { NflGameTeamOdds } from "@/graphql/gql/graphql";
import type { Team } from "../types";
import styles from "./betCard.module.scss";

interface BetCardProps {
  odds?: NflGameTeamOdds | null;
  team?: Team | null;
  isRightSide?: boolean;
}

const BetCard = ({ odds, team, isRightSide }: BetCardProps) => {
  const { moneyLine, spread, total } = odds ?? {};
  const { onOddsClick, redirectToSportsbookProps } =
    useRedirectConfirmationModal("American Football", "NFL", "Nfl schedules");
  const spreadIsMissingData = !(spread?.value && spread?.odd && spread?.url);
  const moneyLineIsMissingData = !(moneyLine?.odd && moneyLine?.url);
  const totalIsMissingData = !(total?.value && total?.odd && total?.url);

  return (
    <div className={styles.betCard}>
      <RedirectToSportsbook {...redirectToSportsbookProps} />
      <Link
        href={`https://sportsbook.fanduel.com/teams/nfl/${team?.slug ?? ""}`}
      >
        <h3 className={cx({ [styles.rightAlign]: isRightSide })}>
          {team?.name ?? ""}
        </h3>
      </Link>
      <div className={styles.oddsContainer}>
        <div className={styles.oddsLabels}>
          <h4>Spread</h4>
          <h4>Moneyline</h4>
          <h4>Total</h4>
        </div>
        <div>
          <OddsBtn
            classButton={styles.oddsBtn}
            isSuspended={spreadIsMissingData}
            handicap={spread?.value}
            odds={spread?.odd ?? "-"}
            onClick={() => onOddsClick(spread?.url ?? "")}
          />
          <OddsBtn
            classButton={styles?.oddsBtn}
            isSuspended={moneyLineIsMissingData}
            odds={moneyLine?.odd ?? "-"}
            onClick={() => onOddsClick(moneyLine?.url ?? "")}
          />
          <OddsBtn
            classButton={styles?.oddsBtn}
            isSuspended={totalIsMissingData}
            handicap={total?.value}
            odds={total?.odd ?? "-"}
            onClick={() => onOddsClick(total?.url ?? "")}
          />
        </div>
      </div>
    </div>
  );
};

export default BetCard;
